export { MorphemeMnemonicsHeroGlyph } from "#morpheme-mnemonics-hero-glyph";
